export class TylTranslation {
	ID: number;
	Language_ID: number;
	English: string;
	Translation: string;
	RichText: boolean;


	constructor(textToTranslate: string, richText: boolean = false) {
		this.English = textToTranslate;
		this.RichText = richText;
	}
}
